// extracted by mini-css-extract-plugin
export default {"applied-filters":"applied-filters_applied-filters__Qfqa5","title":"applied-filters_title__BmQey","pill-wrapper":"applied-filters_pill-wrapper__vG57c"};